import React, { useState, useEffect } from 'react';
import {IProps} from './types';
import * as S from './styles';
import { Rect } from 'react-konva';
import { heightEquilateralTriangle } from 'utils/geometry'

const CornersAddIn: React.FC<IProps> = (props) => {    
    const x1=-3;
    const y1=(props.shapeType==="Line"?((((props.borderWidth??0) * props.scaleX) / 2) - 3) : -3);
    
    let x2=((props.width + (props.borderWidth??0)) * props.scaleX);
    let y2=((props.height + (props.borderWidth??0)) * props.scaleY);
    
    if (props.shapeType==="Triangle") x2 = heightEquilateralTriangle(x2);
    if (props.shapeType==="Triangle") y2 = heightEquilateralTriangle(x2);
    
    x2 = x2-3;
    y2 = y2-3;

    return (
    <>
      {
        props.show &&  
        <>
            <Rect width={6} height={6} fill={'white'} stroke={'#00A1FF'} strokeWidth={1} x={x1} y={y1}/>
            <Rect width={6} height={6} fill={'white'} stroke={'#00A1FF'} strokeWidth={1} x={x2} y={y1}/>
            {
              props.shapeType!=="Line" && 
              <>
                <Rect width={6} height={6} fill={'white'} stroke={'#00A1FF'} strokeWidth={1} x={x1} y={y2}/>
                <Rect width={6} height={6} fill={'white'} stroke={'#00A1FF'} strokeWidth={1} x={x2} y={y2}/>
              </>
            }
        </>
      }
    </>
  );
}
  
export default CornersAddIn;